import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import nl from "./locales/nl.json";
import de from "./locales/de.json";

const STORAGE_KEY = "ui_locale";
const USER_CHOICE_KEY = "ui_locale_user";
const SUPPORTED_LANGS = ["en", "fr", "es", "it", "nl", "de"];

const UI_LANGUAGES = [
  { code: "en" },
  { code: "fr" },
  { code: "es" },
  { code: "it" },
  { code: "nl" },
  { code: "de" },
];


function normalizeLang(lng) {
  const code = String(lng || "").toLowerCase().split(/[-_]/)[0];
  return SUPPORTED_LANGS.includes(code) ? code : null;
}

function getStoredLanguage() {
  try {
    return normalizeLang(localStorage.getItem(STORAGE_KEY));
  } catch (_) {}
  return null;
}

function hasUserLanguageChoice() {
  try {
    return localStorage.getItem(USER_CHOICE_KEY) === "1" && !!getStoredLanguage();
  } catch (_) {}
  return false;
}

function rememberUserLanguage(lng) {
  const code = normalizeLang(lng);
  if (!code) return;
  try {
    localStorage.setItem(USER_CHOICE_KEY, "1");
    localStorage.setItem(STORAGE_KEY, code);
  } catch (_) {}
  if (i18n.resolvedLanguage !== code) {
    void i18n.changeLanguage(code);
  }
}

function getBrowserLanguage() {
  const lang = navigator.language || navigator.userLanguage || "";
  const code = lang.split("-")[0].toLowerCase();
  if (SUPPORTED_LANGS.includes(code)) return code;
  return "en";
}

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  es: { translation: es },
  it: { translation: it },
  nl: { translation: nl },
  de: { translation: de },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGS,
  lng: getStoredLanguage() || getBrowserLanguage(),
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  const code = normalizeLang(lng);
  if (!code) return;
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch (_) {}
});

export default i18n;
export { STORAGE_KEY, SUPPORTED_LANGS, UI_LANGUAGES, hasUserLanguageChoice, rememberUserLanguage };
